export default __webpack_public_path__ + "static/media/Sarah-Roberts.4db2cce3.png";